/** Phase 3 form option vocabularies (mirror backend enums). */

export const SPECIALTIES = [
  { value: "residential", label: "Residential" },
  { value: "luxury", label: "Luxury" },
  { value: "commercial", label: "Commercial" },
  { value: "investors", label: "Investors" },
  { value: "new_construction", label: "New Construction" },
  { value: "first_time_buyers", label: "First-Time Buyers" },
  { value: "relocation", label: "Relocation" },
  { value: "rentals", label: "Rentals" },
  { value: "land", label: "Land" },
  { value: "other", label: "Other" },
];

export const BRAND_VOICES = [
  { value: "professional", label: "Professional" },
  { value: "warm", label: "Warm" },
  { value: "luxury", label: "Luxury" },
  { value: "educational", label: "Educational" },
  { value: "conversational", label: "Conversational" },
  { value: "bold", label: "Bold" },
  { value: "calm", label: "Calm" },
  { value: "approachable", label: "Approachable" },
  { value: "custom", label: "Custom" },
];

export const CONTACT_METHODS = [
  { value: "email", label: "Email" },
  { value: "phone", label: "Phone" },
  { value: "text", label: "Text" },
];

export const US_STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","DC","FL","GA","HI","ID","IL","IN","IA","KS",
  "KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY",
  "NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY",
];
